import { ACTIVE_DIRECTORY_ACCOUNT_TYPE } from 'pages/service-account-creation/constant';

export const isReadyToSubmit = ({ order, isSQLServer, appNameValid, appShortNameValid }) => {
    const conditions = [
        { name: 'applicationName', value: order?.applicationName },
        { name: 'isValidAppName', value: appNameValid },
        { name: 'environment', value: order?.environment },
        { name: 'appOwner', value: order?.appOwner },
        { name: 'applicationOwner', value: order?.applicationOwner },
        { name: 'applicationServiceCI', value: order?.applicationServiceCI },
        { name: 'sector', value: order?.sector },
        { name: 'accountType', value: order?.accountType },
        { name: 'appShortName', value: order?.appShortName },
        { name: 'isValidAppShortName', value: appShortNameValid },
        { name: 'serviceAccName', value: order?.serviceAccName },
    ];

    if (isSQLServer) {
        conditions.push({ name: 'sqlServerName', value: order?.sqlServerName });
    }

    if (order?.accountType === ACTIVE_DIRECTORY_ACCOUNT_TYPE) {
        conditions.push({ name: 'selectedPamSafe', value: !!order?.selectedPamSafe });
    }

    const failedConditions = conditions.filter((condition) => !condition.value);
    const isValid = failedConditions.length === 0;

    return {
        isValid,
        message: isValid ? 'All conditions passed' : `Failed conditions: ${failedConditions.map((c) => c.name).join(', ')}`,
    };
};
export default {};
